function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import * as React from 'react';
import { Box } from "../box";
import { Text } from "../text";
import { Stack } from "../stack";
import { Icon } from "../icon";
import { Position } from "../position";

var getSizeProps = function getSizeProps(props) {
  var icon = props.icon,
      size = props.size;
  var sizes = {
    small: {
      fontSize: 1,
      lineHeight: 1,
      minHeight: '24px',
      paddingLeft: icon ? 5 : 2,
      paddingRight: 2
    },
    medium: {
      fontSize: 2,
      lineHeight: 2,
      minHeight: '32px',
      paddingLeft: icon ? 7 : 3,
      paddingRight: 3
    },
    large: {
      fontSize: 3,
      lineHeight: 3,
      minHeight: '40px',
      paddingLeft: icon ? 9 : 3,
      paddingRight: 3
    }
  };
  return sizes[size];
};

var getIconWrapperProps = function getIconWrapperProps(props) {
  var size = props.size;
  var sizes = {
    small: {
      left: 2
    },
    medium: {
      left: 2
    },
    large: {
      left: 3
    }
  };
  return sizes[size];
};

var _getBaseStyle = function _getBaseStyle(props) {
  return _objectSpread(_objectSpread({
    borderRadius: '2px',
    border: '1px solid',
    borderColor: props.theme.colors.grey['300']
  }, getSizeProps(props)), {}, {
    ':hover': {
      outline: 'none',
      borderColor: props.theme.colors.blue['300']
    },
    ':focus': {
      outline: 'none',
      boxShadow: "0 0 0 1px ".concat(props.theme.colors.blue['300']),
      borderColor: props.theme.colors.blue['300']
    }
  });
};

var Input = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var size = props.size,
      icon = props.icon;
  return /*#__PURE__*/React.createElement(Stack, {
    space: "xSmall"
  }, props.label ? /*#__PURE__*/React.createElement(Text, {
    fontSize: 2,
    fontWeight: 600
  }, props.label) : null, /*#__PURE__*/React.createElement(Position, {
    display: "flex",
    position: "relative"
  }, icon ? /*#__PURE__*/React.createElement(Position, _extends({}, getIconWrapperProps(props), {
    "data-test-id": "icon-wrapper",
    display: 'flex',
    position: "absolute",
    top: '50%',
    bottom: 0,
    sx: {
      transform: 'translateY(-50%)'
    }
  }), /*#__PURE__*/React.createElement(Icon, {
    icon: icon,
    color: "grey.600",
    size: size
  })) : null, /*#__PURE__*/React.createElement(Box, _extends({
    as: "input",
    width: "100%",
    alignItems: "center",
    justifyContent: "center",
    mt: "auto",
    ref: ref,
    _getBaseStyle: _getBaseStyle
  }, props))), props.isLoading ? 'loading' : null);
});
Input.defaultProps = {
  size: 'medium'
};
Input.displayName = 'Input';
export { Input };
export default Input;